module.exports = __webpack_public_path__ + "img/70.57fc4f50.jpeg";